import React, { useState, useEffect } from "react";
import { Form, Input, Button, Card, message, Layout, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";
import Register from "./Register"; // Import Register.js sebagai komponen terpisah
import {
  WarningTwoTone,
  DownOutlined,
  UpOutlined,
  LockOutlined,
  UserOutlined,
} from "@ant-design/icons";
import "./login.css"; // Import CSS untuk animasi transisi

const { Content } = Layout;
const { Title, Text } = Typography;

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [announcement, setAnnouncement] = useState(null);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("/data/announcement.json")
      .then((response) => response.json())
      .then((data) => setAnnouncement(data))
      .catch(() => message.error("Gagal mengambil data announcement"));
  }, []);

  const onLogin = async (values) => {
    setLoading(true);
    try {
      const res = await axiosInstance.post("/auth/login", values);
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", res.data.user.id_user);
      message.success("Login successful");
      navigate("/");
    } catch (error) {
      message.error("Login failed");
    }
    setLoading(false);
  };

  return (
    <Layout className="login-container">
      {/* Bagian Kiri - Announcement */}
      <div className="login-left">
        {/* Announcement */}
        <div
          className="announcement"
          onClick={() => setIsCollapsed(!isCollapsed)}
        >
          <span style={{ color: "navy" }}>
            <WarningTwoTone
              twoToneColor="#FF0000"
              style={{ fontSize: 20, marginRight: 5 }}
            />
            {announcement?.title}
          </span>
          {isCollapsed ? <DownOutlined /> : <UpOutlined />}
        </div>

        {/* Announcement Content */}
        {announcement && !isCollapsed && (
          <div className="announcement-content">
            <ul>
              <li>{announcement.message}</li>
              <li>{announcement.weekly_maintenance}</li>
              <li>{announcement.extended_maintenance}</li>
            </ul>
          </div>
        )}
      </div>

      {/* Bagian Kanan - Login atau Register */}
      <Content className="login-right">
        {!showRegister ? (
          <Card className="login-card">
            <img
              src="https://images.crunchbase.com/image/upload/c_pad,f_auto,q_auto:eco,dpr_1/v1397185652/9a3a585523122dc6c0728459e9a71da0.png"
              alt="Logo"
              style={{ width: 130 }}
            />

            <Title level={3} style={{ marginBottom: 10, color: "#003399" }}>
              <span style={{ fontWeight: "bold" }}>DAILY MEETING APPS</span>
            </Title>
            <Text type="secondary">
              Aplikasi Manajemen Rapat Harian Untuk Keperluan IKU
            </Text>

            <Form
              onFinish={onLogin}
              layout="vertical"
              style={{ marginTop: 20 }}
            >
              <Form.Item
                name="nama_user"
                rules={[{ required: true, message: "Masukkan username" }]}
              >
                <Input
                  size="large"
                  placeholder="Username"
                  prefix={<UserOutlined />}
                />
              </Form.Item>
              <Form.Item
                name="password"
                rules={[{ required: true, message: "Masukkan password" }]}
              >
                <Input.Password
                  size="large"
                  placeholder="Password"
                  prefix={<LockOutlined />}
                />
              </Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                size="large"
                block
              >
                Log in
              </Button>
              <div className="footer-links">
                <a onClick={() => setShowRegister(true)}>Pendaftaran Baru</a>
              </div>
              <div
                style={{
                  textAlign: "center",
                  width: "100%",
                  marginTop: "20px",
                }}
              >
                <Text strong style={{ color: "grey" }}>
                  © {new Date().getFullYear()} DM APPS - Daily Meeting
                  Management System
                </Text>
                <br />
                <Text strong style={{ color: "grey" }}>
                  Created with ❤️ by Anak Tangga
                </Text>
              </div>
            </Form>
          </Card>
        ) : (
          <Register onCancel={() => setShowRegister(false)} />
        )}
      </Content>
    </Layout>
  );
};

export default Login;
